import React, { PureComponent } from 'react';
import { Helmet } from 'react-helmet';

import LocalizedMessage, { localizeMessage } from '../../../../components/LocalizedMessage';
import URLFiltersHoc, { Props } from '../../../../components/URLFiltersHoc';
import Breadcrumbs from '../../../../components/Breadcrumbs';
import TableList from '../../../../components/TableList';

import Alert from '../../../../helpers/alert';
import API from '../../../../api';

interface IState {
  dataList: any[],
  dataListTotal: number;
  isLoading: boolean;

  spend3: any;
  bigMedia: any;
  media: any;
}

class MediaTypes extends PureComponent<Props, IState> {
  state: IState = {
    dataList: [],
    dataListTotal: 1,
    isLoading: false,

    spend3: '',
    bigMedia: '',
    media: ''
  };

  mounted = false;
  refreshListTimer = 0;
  refreshListTimerDelay = 500;
  _form = React.createRef<HTMLFormElement>();

  componentDidMount () {
    this.mounted = true;
    this.refreshList();
  }

  componentDidUpdate (prevProps) {
    if (prevProps.filters !== this.props.filters) {
      this.refreshList();
    }
  }

  componentWillUnmount () {
    this.mounted = false;
    clearTimeout(this.refreshListTimer);
  }

  refreshList () {
    clearTimeout(this.refreshListTimer);
    const { currentPage, currentSort, max } = this.props.filters;
    const dataListRequest = {
      page: currentPage,
      order: currentSort,
      max,
    };

    this.refreshListTimer = window.setTimeout(async () => {
      this.setState({ isLoading: true });

      const dataList = await API.mediaTypes.list(dataListRequest);

      if (!this.mounted) {
        return;
      }

      this.setState({
        dataList: dataList.items,
        dataListTotal: dataList.total,
        isLoading: false
      });
    }, this.refreshListTimerDelay);
  }

  getBreadcrumbs () {
    return [
      {
        title: <LocalizedMessage id='home' />,
        link: '/app'
      },
      {
        title: <LocalizedMessage id='menu.dictionaries.mediaTypes' />,
        link: '/app/dictionaries/mediaTypes'
      }
    ];
  }

  setFormRef = (ref) => {
    this._form = ref;
  };

  handleInputChange = (e) => {
    const value = e.target.value;

    this.setState({
      [e.target.name as 'media']: value
    });
  };

  resetClick = () => {
    if (this._form.current) {
      this._form.current.reset();
    }

    this.setState({
      spend3: null,
      bigMedia: null,
      media: null
    });
  };

  onSubmit = async (e) => {
    e.preventDefault();

    const {
      spend3,
      bigMedia,
      media
    } = this.state;

    if (
      (!spend3 || !spend3.length) ||
      (!bigMedia || !bigMedia.length) ||
      (!media || !media.length)
    ) {
      return;
    }

    try {
      await API.mediaTypes.create({
        spend3: spend3,
        bigMedia: bigMedia,
        media: media
      });

      Alert.success(localizeMessage({ id: 'media-types-dictionary.successfullySent' }));

      this.resetClick();

      this.refreshList();
    } catch (error) {
      console.error(error);

      Alert.success(localizeMessage({ id: 'media-types-dictionary.errorSending' }));
    }
  };

  render () {
    const {
      onUpdateSort, onUpdatePage, filters,
    } = this.props;
    const {
      spend3,
      bigMedia,
      media,
      dataList,
      dataListTotal,
      isLoading
    } = this.state;

    return (
      <>
        <LocalizedMessage
          id='site.title.dictionaries.mediaTypes'
        >
          {localizedMessage => (
            <>
              <Helmet
                title={localizedMessage}
              />
              <Breadcrumbs
                title={localizedMessage}
                data={this.getBreadcrumbs()}
              />
            </>
          )}
        </LocalizedMessage>

        <div className='wrapper wrapper-content'>
          <div className='row'>
            <div className='col-lg-12'>
              <div className='ibox float-e-margins'>
                <div className='ibox-content'>
                  <form
                    ref={this.setFormRef}
                    onSubmit={this.onSubmit}
                  >
                    <div className='form-horizontal'>
                      <div className='form-group'>
                        <label className='col-lg-2 control-label'>
                          <LocalizedMessage id='media-types-dictionary.spend3.label' />
                        </label>

                        <div className='col-lg-10'>
                          <LocalizedMessage id='spend3'>
                            {localizedPlaceholder => (
                              <input
                                type='text'
                                className='form-control'
                                name='spend3'
                                value={spend3}
                                placeholder={localizedPlaceholder}
                                onChange={this.handleInputChange}
                              />
                            )}
                          </LocalizedMessage>
                        </div>
                      </div>

                      <div className='form-group'>
                        <label className='col-lg-2 control-label'>
                          <LocalizedMessage id='media-types-dictionary.bigMedia.label' />
                        </label>

                        <div className='col-lg-10'>
                          <LocalizedMessage id='bigMedia'>
                            {localizedPlaceholder => (
                              <input
                                type='text'
                                className='form-control'
                                name='bigMedia'
                                value={bigMedia}
                                placeholder={localizedPlaceholder}
                                onChange={this.handleInputChange}
                              />
                            )}
                          </LocalizedMessage>
                        </div>
                      </div>

                      <div className='form-group'>
                        <label className='col-lg-2 control-label'>
                          <LocalizedMessage id='media-types-dictionary.media.label' />
                        </label>

                        <div className='col-lg-10'>
                          <LocalizedMessage id='media'>
                            {localizedMessage => (
                              <input
                                type='text'
                                className='form-control'
                                name='media'
                                value={media}
                                placeholder={localizedMessage}
                                onChange={this.handleInputChange}
                              />
                            )}
                          </LocalizedMessage>
                        </div>
                      </div>

                      <div className='hr-line-dashed' />

                      <div className='form-group'>
                        <div className='col-lg-2' />
                        <div className='col-lg-10'>
                          <button
                            className='btn btn-white'
                            onClick={this.resetClick}
                          >
                            <span><LocalizedMessage id='reset' /></span>
                          </button>
                          &nbsp;&nbsp;
                          <button
                            type='submit'
                            className='btn btn-primary'
                            onClick={this.onSubmit}
                            disabled={!spend3 || !bigMedia || !media}
                          >
                            <>
                              <i className='fa fa-chevron-down fa-lg' />
                              <span><LocalizedMessage id='save' /></span>
                            </>
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div className='row'>
            <div className='col-lg-12'>
              <div className='ibox float-e-margins'>
                <div className='ibox-content'>
                  <div className='table-responsive'>
                    <TableList
                      currentPage={filters.currentPage}
                      currentSort={filters.currentSort}
                      totalItems={dataListTotal}
                      itemsCountPerPage={filters.max}
                      onUpdateSort={onUpdateSort}
                      onUpdatePage={onUpdatePage}
                      isLoading={isLoading}
                      head={[
                        {
                          label: localizeMessage({ id: 'id' }),
                          sort: 'id'
                        },
                        {
                          label: localizeMessage({ id: 'spend3' }),
                          sort: 'spend3'
                        },
                        {
                          label: localizeMessage({ id: 'bigMedia' }),
                          sort: 'big_media'
                        },
                        {
                          label: localizeMessage({ id: 'media' }),
                          sort: 'media'
                        }
                      ]}
                    >
                      {
                        dataList.map((row, rowIndex) => (
                          <tr key={rowIndex + '_media-types'}>
                            <td>{row.id}</td>
                            <td>{row.spend3}</td>
                            <td>{row.bigMedia}</td>
                            <td>{row.media}</td>
                          </tr>
                        ))
                      }
                    </TableList>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default URLFiltersHoc(MediaTypes, 'id');
